module.exports = __webpack_public_path__ + "img/coming-soon-dark.9a145a17.svg";